import { render, staticRenderFns } from "./BlocProduits.vue?vue&type=template&id=58bd284a"
import script from "./BlocProduits.vue?vue&type=script&lang=js"
export * from "./BlocProduits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports